import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f84d4df4")

_pushScopeId("data-v-f84d4df4")
const _hoisted_1 = { class: "login_wrap" }
const _hoisted_2 = { class: "login_hd flex_space_center" }
const _hoisted_3 = { class: "hd_left flex_start_center" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "login_tab" }
const _hoisted_6 = { class: "flex_centers" }
const _hoisted_7 = { class: "login_bottom_action" }
const _hoisted_8 = {
  key: 0,
  class: "bottom_title flex_centers"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 微信扫码 ")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, " 关注公众号 ", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 即可 ")
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, " 登录/注册", -1)
const _hoisted_13 = { class: "official_tip" }
const _hoisted_14 = { class: "bottom_subtitle" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "登录即同意", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "和", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FastLogin = _resolveComponent("FastLogin")!
  const _component_OfficiaLogin = _resolveComponent("OfficiaLogin")!
  const _component_PhoneLogin = _resolveComponent("PhoneLogin")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          src: _ctx.viewModel.logo,
          class: "logo_icon",
          alt: ""
        }, null, 8, ["src"]),
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.viewModel.title) + "-快速登录", 1)
      ]),
      _createVNode("span", {
        class: "hd_close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickClose && _ctx.clickClose(...args)))
      })
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_FastLogin, { onUpdateFastLogin: _ctx.updateFastLogin }, null, 8, ["onUpdateFastLogin"])
    ], 512), [
      [_vShow, _ctx.viewModel.showFastLogin]
    ]),
    (!_ctx.viewModel.showFastLogin)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("ul", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viewModel.tabs, (l, i) => {
                return (_openBlock(), _createBlock("li", {
                  key: i,
                  onClick: ($event: any) => (_ctx.toggleTab(i))
                }, _toDisplayString(l), 9, ["onClick"]))
              }), 128)),
              _createVNode("div", {
                class: ['tab_active', { phone: _ctx.viewModel.tabIdx === 1 }]
              }, null, 2)
            ])
          ]),
          (_ctx.viewModel.tabIdx === 0)
            ? (_openBlock(), _createBlock(_component_OfficiaLogin, {
                key: 0,
                "show-fast-login": _ctx.viewModel.showFastLogin
              }, null, 8, ["show-fast-login"]))
            : (_openBlock(), _createBlock(_component_PhoneLogin, { key: 1 })),
          _createVNode("div", _hoisted_7, [
            (_ctx.viewModel.tabIdx === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _createVNode("i", _hoisted_13, [
                    _createVNode("img", {
                      class: "guide_bg",
                      src: _ctx.viewModel.officialLoginImg,
                      alt: ""
                    }, null, 8, ["src"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("span", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openMemberProtocol && _ctx.openMemberProtocol(...args)))
              }, "《会员服务使用协议》"),
              (_ctx.showPrivacyPolicy)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_16,
                    _createVNode("span", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openPrivacyPolicy && _ctx.openPrivacyPolicy(...args)))
                    }, "《隐私政策》")
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.isShow)
            ? (_openBlock(), _createBlock("div", {
                key: 2,
                class: "comp_login flex_column_centers",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.switchOldAccountLogin && _ctx.switchOldAccountLogin(...args)))
              }, [
                _createVNode("img", {
                  src: _ctx.viewModel.oldAccountLoginInfo.img
                }, null, 8, ["src"]),
                _createVNode("span", null, _toDisplayString(_ctx.viewModel.oldAccountLoginInfo.text), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
})